module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-supply-chain-hero.ad917ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-supply-chain-hero.jpg
// module id = cAli
// module chunks = 0